import { ID, Query } from 'appwrite';
import {
  databases,
  DATABASE_ID,
  COLLECTION_ID_TASK_COMMENTS,
} from '../config/appwrite';
import { readAuthSession } from './authService';

/**
 * Task comments — collection TaskCommentsSGM
 */

const formatComment = (doc) => ({
  id: doc.$id,
  documentId: doc.$id,
  taskId: doc.taskId || '',
  body: doc.body || '',
  authorId: doc.authorId || '',
  authorName: doc.authorName || '',
  authorEmail: doc.authorEmail || '',
  createdAt: doc.$createdAt || null,
});

export const getCommentsByTaskId = async (taskId) => {
  if (!taskId) return [];
  try {
    const response = await databases.listDocuments(
      DATABASE_ID,
      COLLECTION_ID_TASK_COMMENTS,
      [
        Query.equal('taskId', String(taskId)),
        Query.orderAsc('$createdAt'),
        Query.limit(200),
      ]
    );
    return response.documents.map(formatComment);
  } catch (error) {
    console.error('Error fetching task comments:', error);
    if (
      error.code === 404 ||
      error.message?.includes('not found') ||
      error.message?.includes('Collection')
    ) {
      console.warn(
        'Task comments collection not found. Run: npm run setup:task-comments'
      );
      return [];
    }
    throw error;
  }
};

export const createComment = async ({ taskId, body }) => {
  const session = readAuthSession();
  const text = String(body || '').trim();
  if (!taskId) throw new Error('Missing task id');
  if (!text) throw new Error('Comment cannot be empty');
  if (!session?.userId && !session?.email) {
    throw new Error('You must be signed in to comment');
  }

  const documentData = {
    taskId: String(taskId),
    body: text,
    authorId: String(session.userId || session.email),
    authorName: String(session.name || session.email || 'User'),
    authorEmail: String(session.email || ''),
  };

  const response = await databases.createDocument(
    DATABASE_ID,
    COLLECTION_ID_TASK_COMMENTS,
    ID.unique(),
    documentData
  );
  return formatComment(response);
};

export const deleteComment = async (commentId) => {
  if (!commentId) throw new Error('Missing comment id');
  await databases.deleteDocument(
    DATABASE_ID,
    COLLECTION_ID_TASK_COMMENTS,
    commentId
  );
  return { success: true };
};
